/* eslint-disable react/prop-types */
import React from 'react';
// eslint-disable-next-line no-unused-vars
import { withRouter } from 'react-router';
import { motion } from 'framer-motion';
import Grid from '@material-ui/core/Grid';
import { Box } from '@material-ui/core';
import TextFieldPurple from './TextFieldPurple';
import ColorButtonPurple from './ColorButtonPurple.js';
import ColorButtonWhite from './ColorButtonWhite.js';
import CopyRight from './CopyRight.js';
import StepBar from './StepBar.js';
import { Link } from 'react-router-dom';
import firebase, { db } from '../Firebase.js';

class Step4 extends React.Component {
  constructor(props) {
    super(props);
    this.state = { numColorRemoteFeeP: '#BCBCBC', numColorTeatejukyu: '#BCBCBC' };
  }

  handeleFocusRemoteFeeP() {
    this.setState({ numColorRemoteFeeP: 'black' });
  }

  handeleFocusTeatejukyu() {
    this.setState({ numColorTeatejukyu: 'black' });
  }

  handleToStep3 = () => {
    // eslint-disable-next-line react/prop-types
    this.props.history.push('/step3');
  };
  handleToResult = () => {
    // eslint-disable-next-line react/prop-types
    this.props.history.push('/result');
  };

  //データベースに追加
  addToDatabese() {
    const docId = db.collection('work-palce-simulator-trial').doc().id;
    db.collection('work-palce-simulator-trial')
      .doc(docId)
      .set({
        docId: docId,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        action: 'FINISH',
        name: '',
        company: '',
        busho: '',
        email: '',
        people: Number(this.props.data.office_people),
        area: Number(this.props.data.office_area),
        rent: Number(this.props.data.office_rent),
        kako_free: Number(this.props.data.kako_free),
        now_free: Number(this.props.data.now_free),
        new_free: Number(this.props.data.new_free),
        kako_shusha: Number(this.props.data.kako_shusha),
        now_shusha: Number(this.props.data.now_shusha),
        new_shusha: Number(this.props.data.new_shusha),
        kako_remotefeeP: this.props.data.kako_remotefeeP,
        now_remotefeeP: this.props.data.now_remotefeeP,
        new_remotefeeP: this.props.data.new_remotefeeP,
        kako_teatejukyu: Number(this.props.data.kako_teatejukyu),
        now_teatejukyu: Number(this.props.data.now_teatejukyu),
        new_teatejukyu: Number(this.props.data.new_teatejukyu),
      });
  }

  render() {
    return (
      <div>
        <motion.div
          className="contents-inner"
          animate={{
            x: 0,
            opacity: 1,
          }}
          initial={{
            x: 100,
            opacity: 0,
          }}
          exit={{
            x: -100,
            opacity: 0,
          }}
          transition={{
            duration: 0.2,
          }}
        >
          <Box paddingBottom={3}>
            <h2 className="question">
              在宅勤務などオフィス以外での手当てがある場合は
              <br />
              入力可能です。
              <br />
              こちらは必須ではありません。
            </h2>
          </Box>

          <h3 className="imput-tittle">リモートワーク手当</h3>
          <Grid container justify="center">
            <Grid item xs={2}>
              <Box textAlign="right" paddingRight={1}>
                <p className="imput-tittle">一人当たり</p>
              </Box>
            </Grid>
            <Grid item xs={2}>
              <TextFieldPurple
                id="outlined-basic"
                margin="dense"
                variant="outlined"
                onChange={(e) => {
                  this.props.handleOfficeRemoteFeePChange(e.target.value);
                }}
                onFocus={() => this.handeleFocusRemoteFeeP()}
                value={this.props.data.office_remotefeeP}
                inputProps={{
                  style: {
                    fontSize: 30,
                    textAlign: 'center',
                    fontFamily: 'Noto Sans JP',
                    color: this.state.numColorRemoteFeeP,
                  },
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <Box textAlign="left" paddingLeft={1}>
                <p className="imput-tittle">万円/月</p>
              </Box>
            </Grid>
          </Grid>

          <Box paddingTop={1}>
            <h3 className="imput-tittle">受給者割合</h3>
          </Box>

          <Grid container justify="center">
            <Grid item xs={2}>
              <Box textAlign="right" paddingRight={1}>
                <p className="imput-tittle">全社員当たり</p>
              </Box>
            </Grid>
            <Grid item xs={2}>
              <TextFieldPurple
                id="outlined-basic"
                margin="dense"
                variant="outlined"
                onChange={(e) => {
                  this.props.handleOfficeTeateJukyuChange(e.target.value);
                }}
                onFocus={() => this.handeleFocusTeatejukyu()}
                value={this.props.data.office_teatejukyu}
                inputProps={{
                  style: {
                    fontSize: 30,
                    textAlign: 'center',
                    fontFamily: 'Noto Sans JP',
                    color: this.state.numColorTeatejukyu,
                  },
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <Box textAlign="left" paddingLeft={1}>
                <p className="imput-tittle">%</p>
              </Box>
            </Grid>
          </Grid>

          <Box paddingTop={8}>
            <Grid container justify="center">
              <Grid item xs={2}>
                <Box m={1} textAlign="right">
                  <ColorButtonWhite size="large" variant="outlined" component={Link} to="/step3">
                    BACK
                  </ColorButtonWhite>
                </Box>
              </Grid>
              <Grid item xs={2}>
                <Box m={1} textAlign="left">
                  <ColorButtonPurple
                    size="large"
                    variant="outlined"
                    component={Link}
                    to="/result"
                    onClick={() => {
                      this.props.setTeate();
                      this.props.calc();
                      this.addToDatabese();
                    }}
                  >
                    FINISH
                  </ColorButtonPurple>
                </Box>
              </Grid>
            </Grid>
          </Box>
          <StepBar step="step4" />
          <Box marginTop={2}>
            <CopyRight />
          </Box>
        </motion.div>
      </div>
    );
  }
}

export default Step4;
